import { types } from 'mobx-state-tree';
import TermModel from './term.model';
import ErrorModel from './error.model';
import ExperimentModel from './experiment.model';
import CreditsBalanceModel from './creditsBalance.model';

const SharedStoreModel = types.model('SharedStore', {
  errors: types.array(ErrorModel),
  displayConnectionModal: false,
  displayPendingTermsModal: false,
  currentLiabilityTerms: types.maybe(TermModel),
  currentPrivacyTerms: types.maybe(TermModel),
  isDiscountAllowed: true,
  experiment: types.maybe(ExperimentModel),
  creditsBalance: types.maybe(CreditsBalanceModel),
  currentQuotePolicyStep: 'step-data',
  displayOnboardingModal: false,
  currentResolution382Terms: types.maybe(TermModel),
  currentJudicialNoRefundTerms: types.maybe(TermModel),
});

export default SharedStoreModel;
